export default "__VITE_ASSET__G3wO5mcV__"